export const setLocalStorage = (name: string, content: string) => {
	localStorage.setItem(`Scoreplan${name}`, content);
};

export const getLocalStorage = (name: string) => localStorage.getItem(`Scoreplan${name}`);

export const removeLocalStorage = (name: string) => {
	localStorage.removeItem(`Scoreplan${name}`);
};
